module.exports = __webpack_public_path__ + "img/icon-setting-0draw.34334012.png";